export enum ArticlePackage {
  SILO = 'SILO',
  SACK = 'SACK',
  BIG_BAG = 'BIG_BAG',
  CONTAINER = 'CONTAINER',
  LOS = 'LOS',
  UNKNOWN = 'UNKNOWN',
}
